var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('NavBar',{attrs:{"isShowLeft":false}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":require("../img/success.png"),"alt":""}})]),_c('div',{staticClass:"submit-text"},[_vm._v("您已成功提交理赔信息!")])])
}]

export { render, staticRenderFns }